export type EventTypeString = 'CLOSING_FINISHED';

export const eventType: EventTypeString = 'CLOSING_FINISHED';

export type EventType = {
  type: EventTypeString,
};

export const eventBuilder = (): EventType => ({
  type: eventType,
});
